import { toast } from "react-toastify";
import { HYPER_ADDRESS, LOGO_URL, TOKEN_SYMBOL, NETWORKID_ACTIVE } from "./constants";

export const addTokenToMetaMask = async () => {
  const tokenAddress = HYPER_ADDRESS;
  const tokenSymbol = TOKEN_SYMBOL;
  const tokenDecimals = 18;
  const tokenImage = LOGO_URL;

  try {
    const wasAdded = await window.ethereum.request({
      method: 'wallet_watchAsset',
      params: {
        type: 'ERC20',
        options: {
          address: tokenAddress,
          symbol: tokenSymbol,
          decimals: tokenDecimals,
          image: tokenImage,
        },
      },
    });

    if (wasAdded) {
      toast.success("Token added!");
    } else {
      toast.error("User rejected token addition.");
    }
  } catch (error) {
    toast.error("Error adding token");
    console.error('Error adding token:', error);
  }
};

export const addBSCNetwork = async () => {
  try {
    if (!window.ethereum) {
      toast.error("MetaMask not found!");
      return;
    }

    await window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: "0x38", // BSC Mainnet (decimal 56)
          chainName: "Binance Smart Chain",
          nativeCurrency: {
            name: "BNB",
            symbol: "BNB",
            decimals: 18,
          },
          rpcUrls: ["https://bsc-dataseed.binance.org/"],
          blockExplorerUrls: ["https://bscscan.com"],
        },
      ],
    });
    toast.success("BSC added successfully!");
  } catch (error: any) {
    toast.error("Error adding BSC");
    console.error("❌ Error adding BSC:", error.message || error);
  }
};

